import { Routes } from '@angular/router';
import { ChangeViewerComponent } from './change-viewer.component';
import { RegulatoryDashboardComponent } from './regulatory-dashboard/regulatory-dashboard.component';
import { ChangeViewerLandingComponent } from './change-viewer-landing/change-viewer-landing.component';
import { TrendingTopicsDashboardComponent } from './trending-topics-dashboard/trending-topics-dashboard.component';

export const ChangeViewerRoutes: Routes = [{
  path: '',
  component: ChangeViewerLandingComponent,
  children: [
    {
      path: 'regulatory-dashboard',
      component: RegulatoryDashboardComponent
    },
    {
      path: 'trending-dashboard',
      component: TrendingTopicsDashboardComponent
    },
    {
      path: 'open',
      component: ChangeViewerComponent
    },
    {
      path: 'regulation-library/:id/:type',
      component: ChangeViewerComponent
    },
    {
      path: 'future-updates',
      component: ChangeViewerComponent
    },
    {
      path: 'other-updates',
      component: ChangeViewerComponent
    },
    {
      path: 'actioned',
      component: ChangeViewerComponent
    },
  ]
}];
